import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListVideos from '../../components/content/list-videos.component';

const ContentVideosView = () => {
  const pageTitle = 'Engagement / Views by Video';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListVideos />
    </AppLayout>
  );
};

export default ContentVideosView;
